// ------------------------------------
// Imports
// ------------------------------------

import { API_REQUEST_STATUS_LOADING, API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'

// ------------------------------------
// Constants
// ------------------------------------

/* actualizar estados desde la Storage */
export const SET_UPDATE_SESSION = 'SET_UPDATE_SESSION';

export const GET_LABELS = 'GET_LABELS';
export const GET_LABELS_FAILED = 'GET_LABELS_FAILED';
export const GET_LABELS_SUCCEEDED = 'GET_LABELS_SUCCEEDED';

export const TOGGLE_LABEL = 'TOGGLE_LABEL';
export const TOGGLE_LABEL_FAILED = 'TOGGLE_LABEL_FAILED';
export const TOGGLE_LABEL_SUCCEDED = 'TOGGLE_LABEL_SUCCEDED';

export const GET_QUESTIONNAIRES = 'GET_QUESTIONNAIRES';
export const GET_QUESTIONNAIRES_FAILED = 'GET_QUESTIONNAIRES_FAILED';
export const GET_QUESTIONNAIRES_SUCCEEDED = 'GET_QUESTIONNAIRES_SUCCEEDED';

export const TOGGLE_QUESTIONNAIRE = 'TOGGLE_QUESTIONNAIRE';
export const TOGGLE_QUESTIONNAIRE_FAILED = 'TOGGLE_QUESTIONNAIRE_FAILED';
export const TOGGLE_QUESTIONNAIRE_SUCCEDED = 'TOGGLE_QUESTIONNAIRE_SUCCEDED';

export const REFRESH_SESSION = 'REFRESH_SESSION';
export const REFRESH_SESSION_FAILED = 'REFRESH_SESSION_FAILED';
export const REFRESH_SESSION_SUCCEEDED = 'REFRESH_SESSION_SUCCEEDED';

// ------------------------------------
// Actions
// ------------------------------------

export function getLabelsAdmin(token) {
    return {
        type : GET_LABELS,
        token
    }
}

export function getLabelsAdminFailed(error) {
    return {
        type : GET_LABELS_FAILED,
        error
    }
}

export function getLabelsAdminSucceeded(labels) {
    return {
        type : GET_LABELS_SUCCEEDED,
        labels
    }
}

export function toggleLabel(token, idEtiqueta, active){
    return {
        type: TOGGLE_LABEL,
        token,
        idEtiqueta,
        active
    }
}

export function toggleLabelFailed(error){
    return {
        type: TOGGLE_LABEL_FAILED,
        error
    }
}

export function toggleLabelSucceeded({pkEtiqueta, changeAccepted}){
    return {
        type: TOGGLE_LABEL_SUCCEDED,
        pkEtiqueta,
        changeAccepted
    }
}

export function getQuestionnairesAdmin(token) {
    return {
        type : GET_QUESTIONNAIRES,
        token
    }
}

export function getQuestionnairesAdminFailed(error) {
    return {
        type : GET_QUESTIONNAIRES_FAILED,
        error
    }
}

export function getQuestionnairesAdminSucceeded(questionnaires) {
    return {
        type : GET_QUESTIONNAIRES_SUCCEEDED,
        questionnaires
    }
}

export function toggleQuestionnaire(token, idCuestionario, active){
    return {
        type: TOGGLE_QUESTIONNAIRE,
        token,
        idCuestionario,
        active
    }
}

export function toggleQuestionnaireFailed(error){
    return {
        type: TOGGLE_QUESTIONNAIRE_FAILED,
        error
    }
}

export function toggleQuestionnaireSucceeded({pkCuestionario, changeAccepted}){
    return {
        type: TOGGLE_QUESTIONNAIRE_SUCCEDED,
        pkCuestionario,
        changeAccepted
    }
}

export function setUpdateSession(data) {
    return {
        type : SET_UPDATE_SESSION,
        payload : data
    }
}

export function refreshSession(token){
    return {
        type: REFRESH_SESSION,
        token
    }
}

export function refreshSessionFailed(error){
    return {
        type: REFRESH_SESSION_FAILED,
        error
    }
}

export function refreshSessionSucceeded({token, endHour}){
    return {
        type: REFRESH_SESSION_SUCCEEDED,
        token,
        endHour
    }
}

export const actions = {
    getLabelsAdmin,
    toggleLabel,
    getQuestionnairesAdmin,
    toggleQuestionnaire,
    refreshSession
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

    [GET_LABELS]: (state, action) => ({
        ...state,
        loading: true
    }),

    [GET_LABELS_FAILED]: (state, action) => ({
        ...state,
        labels: [],
        loading: false
    }),

    [GET_LABELS_SUCCEEDED]: (state, {labels}) => ({
        ...state,
        labels,
        loading: false
    }),

    [TOGGLE_LABEL]: (state, action) => ({
        ...state,
        loading: true,
    }),

    [TOGGLE_LABEL_FAILED] : (state, action) => ({
        ...state,
        loading: false
    }),

    [TOGGLE_LABEL_SUCCEDED]: (state, {pkEtiqueta, changeAccepted}) => ({
        ...state,
        labels: state.labels.map( label => ({
            ...label,
            activo: label.pkEtiqueta === pkEtiqueta && changeAccepted ? !label.activo : label.activo
        })),
        loading: false
    }),

    [GET_QUESTIONNAIRES]: (state, action) => ({
        ...state,
        loading: true
    }),

    [GET_QUESTIONNAIRES_FAILED]: (state, action) => ({
        ...state,
        questionnaires: [],
        loading: false
    }),

    [GET_QUESTIONNAIRES_SUCCEEDED]: (state, {questionnaires}) => ({
        ...state,
        questionnaires,
        loading: false
    }),

    [TOGGLE_QUESTIONNAIRE]: (state, action) => ({
        ...state,
        loading: true,
    }),

    [TOGGLE_QUESTIONNAIRE_FAILED] : (state, action) => ({
        ...state,
        loading: false
    }),

    [TOGGLE_QUESTIONNAIRE_SUCCEDED]: (state, {pkCuestionario, changeAccepted}) => ({
        ...state,
        questionnaires: state.questionnaires.map( questionnaire => ({
            ...questionnaire,
            activo: questionnaire.pkCuestionario === pkCuestionario && changeAccepted ? !questionnaire.activo : questionnaire.activo
        })),
        loading: false
    }),

    [SET_UPDATE_SESSION] : (state, action) => ({
        ...state,
        tokenAdmin: action.payload.token,
        userName: action.payload.userName,
    }),

    [REFRESH_SESSION_SUCCEEDED] : (state, {token, endHour}) => ({
        ...state,
        tokenAdmin: token,
        endSessionTime: endHour
    })
};

const initialState = {
    userName : '',
    getTokenAdminStatus : -1,
    getTokenAdminError : -1,
    labels: [],
    questionnaires: [],
    loading: false,
    initSessionTime: null,
    endSessionTime: null
};

export default function adminReducer (state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type]

    return handler ? handler(state, action) : state
}


// WEBPACK FOOTER //
// ./src/store/modules/module_admin.js